import React from 'react';
import { withNamespaces } from 'react-i18next';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { historyPunch, detailPunch } from '../../actions/punch';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import $ from 'jquery';
import { formatDate } from '../../utils';
import PunchDetail from './PunchDetail';
import styles from '../../styles/punch.module.css';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import i18next from 'i18next';

const stylesMat = theme => ({
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        paddingBottom: '10px!important',
        color: '#3f51b5 !important'
    }
});

class PunchHistory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            dataDetail: [],
            defaultProps: [],
            open: false,
            isActive: true
        }
    }

    componentDidMount() {
        this.loadHistory();
        this.resizeList();
    }

    loadHistory = () => {
        historyPunch().then((response) => {
            this.setState({ data: JSON.parse(response.punch), isActive: false });
        });
    }

    handleClick = (punchId) => {
        this.detailPunch(punchId);
    }

    detailPunch = (punchId) => {
        this.loadDetail(punchId);
        this.setState({ open: true });
    }

    loadDetail = (punchId) => {
        detailPunch(punchId).then((response) => {
            this.setState({ dataDetail: JSON.parse(response.detail) }, () => {
            });
        });
    }

    resizeList() {
        setTimeout(function () {
            const height = $('body').height();
            const header = $('.makeStyles-root-1').height();

            const customHeight = height - header;

            $('div[data-id=divList]').css('height', `${customHeight}px`);
        }, 1000);
    }

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { t } = this.props;
        const { classes } = this.props;

        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('expenseAccount:form.loading')}
            >
                <div data-id="divList" className={styles.konekCard}>
                    <List>
                        {this.state.data.map((obj, index) =>
                            <React.Fragment key={index}>
                                <ListItem className="listItem"  key={index} button onClick={() => this.handleClick(obj.PunchId)}>
                                    <ListItemText disableTypography={true} primary={
                                        <React.Fragment>
                                            <div className={styles.titleDate}>
                                                {formatDate(obj.PunchStart, 'date')}
                                            </div>
                                            <div className={`${styles.titleStartTime} ${styles.titleTime}`}>
                                                {`${t('punch:history.title.begin')}${i18next.t('common:labelSeparator')} ${formatDate(obj.PunchStart, 'time')}`}
                                            </div>
                                            <div className={`${styles.titleEndTime} ${styles.titleTime}`}>
                                                {obj.PunchEnd != null && 
                                                    `${t('punch:history.title.end')}${i18next.t('common:labelSeparator')} ${formatDate(obj.PunchEnd, 'time')}`
                                                }
                                                {obj.PunchEnd == null && '\u00A0'}
                                            </div >
                                            <div className={`${styles.titleStartTime} ${styles.titleTime}`}>
                                                {`${t('punch:history.title.realBegin')}${i18next.t('common:labelSeparator')} ${formatDate(obj.PunchRealStart, 'time')}`}
                                            </div>
                                            <div className={`${styles.titleRealEndTime} ${styles.titleTime}`}>
                                                {obj.PunchRealEnd != null && 
                                                    `${t('punch:history.title.realEnd')}${i18next.t('common:labelSeparator')} ${formatDate(obj.PunchRealEnd, 'time')}`
                                                }
                                                {obj.PunchRealEnd == null && '\u00A0'}
                                            </div >
                                        </React.Fragment>
                                    } secondary={
                                        <React.Fragment>
                                            <div className={styles.divDetail}>
                                                <span className={styles.subtitleDepartment}>
                                                    {`${t('punch:history.subtitle.department')}${i18next.t('common:labelSeparator')} ${obj.DepartmentCode}`}
                                                </span>
                                                <span className={styles.subtitleJobTitle}>
                                                    {`${t('punch:history.subtitle.jobTitle')}${i18next.t('common:labelSeparator')} ${obj.JobTitle}`}
                                                </span>
                                            </div>
                                        </React.Fragment>
                                    } />

                                    <ListItemSecondaryAction className={classes.divAction}>
                                        <IconButton className={classes.icons} edge="end">
                                            <div className={styles.isRefundable}><AssignmentIcon className={classes.icons} /></div>
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </React.Fragment>
                        )}
                    </List>
                    <PunchDetail open={this.state.open} onClose={this.handleClose} data={this.state.dataDetail} />
                </div>
            </LoadingOverlay>
        )
    }
}

export default withNamespaces(['punch', 'geolocation', 'expenseAccount', 'common'], { wait: true })((withStyles(stylesMat)(PunchHistory)));